"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContent = exports.StyledCollapsibleTrigger = exports.StyledCollapsibleTriggerText = void 0;
const react_collapsible_1 = require("@radix-ui/react-collapsible");
const styled_components_1 = __importStar(require("styled-components"));
const Text_1 = require("../../components/Text/Text");
const focusHover_1 = require("../../styles/focusHover");
const Tokens = __importStar(require("../../styles/tokens"));
const tokens_1 = require("../../styles/tokens");
exports.StyledCollapsibleTriggerText = (0, styled_components_1.default)(Text_1.Text).attrs({
    skinny: true,
}) `
    text-decoration: underline;
    color: ${Tokens.COLOURS.primary.blue["100"]};
    text-align: left;
    margin-left: ${Tokens.SIZES[0.5]};

    &:hover,
    &:focus {
        color: ${Tokens.COLOURS.primary.blue["130"]};
    }
`;
exports.StyledCollapsibleTrigger = (0, styled_components_1.default)(react_collapsible_1.Trigger) `
    border: none;
    background: none;
    padding: ${Tokens.SIZES[1]} ${Tokens.SIZES[1]} ${Tokens.SIZES[1]} 0;
    display: flex;
    align-items: flex-start;

    &:hover,
    &:focus {
        border-radius: ${tokens_1.BORDERS.radius};
    }

    /* Ensure focus styling defined here always overrides global styles using more specific selector when using this */
    &:focus&:focus,
    &:focus-visible {
        ${focusHover_1.focusOnlyStyles}
    }
`;
const animationStyles = (0, styled_components_1.css) `
    @keyframes fadeIn {
        from {
            height: 0;
        }
        to {
            height: var(--radix-collapsible-content-height);
        }
    }
    @keyframes fadeOut {
        from {
            height: var(--radix-collapsible-content-height);
        }
        to {
            height: 0;
        }
    }
    overflow-y: hidden;
    &[data-state="open"] {
        animation: fadeIn 300ms ease-out;
    }
    &[data-state="closed"] {
        animation: fadeOut 300ms ease-in;
    }
`;
exports.StyledContent = (0, styled_components_1.default)(react_collapsible_1.Content) `
    box-shadow: inset ${Tokens.SIZES[0.5]} 0 0
        ${Tokens.COLOURS.greyscale.silver};
    padding: ${Tokens.SIZES[0.5]} 0 ${Tokens.SIZES[0.5]} 18px;
    margin-left: 10px;
    margin-top: ${Tokens.SIZES[0.5]};
    ${({ $animated }) => $animated && animationStyles}

    p {
        color: ${Tokens.COLOURS.greyscale.metal};
        margin: 0;
    }

    p + p {
        margin-top: ${Tokens.SIZES[2]};
    }
`;
//# sourceMappingURL=CollapsibleInfo.styles.js.map